module.exports = __webpack_public_path__ + "static/Finland-3d212e9daffdc0463cb6ab30eea103e8.jpg";